import { Link } from "react-router-dom";
import { Wrench, Info } from "lucide-react";

export default function MobileStickyCTA() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="fixed inset-x-0 bottom-0 z-40 md:hidden"
      role="region"
      aria-label="Quick actions"
    >
      <div className="pointer-events-none absolute inset-x-0 -top-6 h-6 bg-gradient-to-t from-white/95 to-transparent" />
      <div className="border-t border-mist-line bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
        <div className="container-page flex items-center gap-2 py-2.5">
          <Link
            to="/request-service"
            data-testid="mobile-cta-request-service"
            className="flex flex-1 items-center justify-center gap-2 rounded-full bg-navy px-4 py-3 text-sm font-semibold text-white shadow-soft active:scale-[0.99]"
          >
            <Wrench className="h-4 w-4 text-aqua" />
            Request Service
          </Link>
          <Link
            to="/demo"
            data-testid="mobile-cta-demo-info"
            className="flex flex-1 items-center justify-center gap-2 rounded-full border border-navy/15 bg-white px-4 py-3 text-sm font-semibold text-navy active:scale-[0.99]"
          >
            <Info className="h-4 w-4 text-sun" />
            Demo Info
          </Link>
        </div>
      </div>
    </div>
  );
}
